// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Col,
//   Card,
//   CardBody,
//   Nav,
//   NavItem,
//   NavLink,
//   TabContent,
//   TabPane,
// } from "reactstrap";
// import classnames from "classnames";
// import { SearchTableEPO } from "../../pages/Tables/ReactTables/ReactTable";
// import CreateEpoForm from "./CreateEpoForm";
// import api from "../../api";
// import "react-toastify/dist/ReactToastify.css";

// const getSubsArray = (node) => {
//   if (!node) return [];
//   const s = node.subordinates ?? node.Subordinates;
//   if (Array.isArray(s)) return s;
//   if (s?.$values && Array.isArray(s.$values)) return s.$values;
//   return [];
// };

// const findNodeByEmpId = (root, empId) => {
//   if (!root || !empId) return null;

//   const stack = [];
//   if (Array.isArray(root)) stack.push(...root);
//   else stack.push(root);

//   while (stack.length) {
//     const cur = stack.pop();
//     const curId = cur.empId ?? cur.EmpId;
//     if (String(curId) === String(empId)) return cur;

//     const kids = getSubsArray(cur);
//     for (let i = 0; i < kids.length; i++) stack.push(kids[i]);
//   }

//   return null;
// };

// const normalizeEmpId = (s) => {
//   const v = s?.empId ?? s?.EmpId ?? "";
//   return v ? String(v) : "";
// };

// const AllTasks = () => {
//   const userId = JSON.parse(sessionStorage.getItem("authUser"))?.uid;

//   const [showCreate, setShowCreate] = useState(false);
//   const [editingEpoNumber, setEditingEpoNumber] = useState(null);

//   const [activeTab, setActiveTab] = useState("mine");
//   const toggleTab = (tab) => {
//     if (activeTab !== tab) setActiveTab(tab);
//   };

//   const [mineRows, setMineRows] = useState([]);
//   const [awaitingRows, setAwaitingRows] = useState([]);
//   const [subsRows, setSubsRows] = useState([]);

//   const [loadingMine, setLoadingMine] = useState(true);
//   const [loadingAwaiting, setLoadingAwaiting] = useState(false);
//   const [loadingSubs, setLoadingSubs] = useState(false);

//   const [directReports, setDirectReports] = useState([]);

//   const hasDirectReports = useMemo(
//     () => (directReports?.length || 0) > 0,
//     [directReports]
//   );

//   const loadMineEpos = async () => {
//     setLoadingMine(true);
//     try {
//       const res = await api.get(`Epo/all?type=ALL&empId=${userId}`);
//       setMineRows(Array.isArray(res.data?.results) ? res.data.results : []);
//     } finally {
//       setLoadingMine(false);
//     }
//   };

//   const loadAwaitingMyApproval = async () => {
//     setLoadingAwaiting(true);
//     try {
//       const res = await api.get(`Epo/awaiting/${userId}`);
//       const results = Array.isArray(res.data?.results)
//         ? res.data.results
//         : Array.isArray(res.data)
//           ? res.data
//           : [];
//       setAwaitingRows(results);
//     } finally {
//       setLoadingAwaiting(false);
//     }
//   };

//   const loadSubordinatesPending = async (subs) => {
//     setLoadingSubs(true);
//     try {
//       const fetches = (subs || [])
//         .map((s) => normalizeEmpId(s))
//         .filter(Boolean)
//         .map((empId) =>
//           api
//             .get(`Epo/all?type=PENDING&empId=${empId}`)
//             .then((r) => r.data)
//             .catch(() => ({ results: [] }))
//         );

//       const all = await Promise.all(fetches);

//       const merged = all
//         .flatMap((x) => (Array.isArray(x?.results) ? x.results : []))
//         .filter(
//           (v, i, arr) =>
//             arr.findIndex((z) => z.epoNumber === v.epoNumber) === i
//         );

//       setSubsRows(merged);
//     } finally {
//       setLoadingSubs(false);
//     }
//   };

//   useEffect(() => {
//     if (!userId) return;

//     let cancelled = false;

//     const init = async () => {
//       try {
//         const mineRes = await api.get(`Epo/all?type=ALL&empId=${userId}`);
//         if (!cancelled) {
//           setMineRows(Array.isArray(mineRes.data?.results) ? mineRes.data.results : []);
//         }
//       } finally {
//         if (!cancelled) setLoadingMine(false);
//       }

//       try {
//         const orgRes = await api.get("OrgChart");
//         const root = orgRes.data;
//         const me = findNodeByEmpId(root, userId);
//         const subs = getSubsArray(me);

//         if (!cancelled) setDirectReports(subs);

//         if (subs.length > 0) {
//           await Promise.all([
//             (async () => {
//               try {
//                 const res = await api.get(`Epo/awaiting/${userId}`);
//                 if (cancelled) return;
//                 const results = Array.isArray(res.data?.results)
//                   ? res.data.results
//                   : Array.isArray(res.data)
//                     ? res.data
//                     : [];
//                 setAwaitingRows(results);
//               } finally {
//                 if (!cancelled) setLoadingAwaiting(false);
//               }
//             })(),
//             (async () => {
//               try {
//                 const fetches = subs
//                   .map((s) => normalizeEmpId(s))
//                   .filter(Boolean)
//                   .map((empId) =>
//                     api
//                       .get(`Epo/all?type=PENDING&empId=${empId}`)
//                       .then((r) => r.data)
//                       .catch(() => ({ results: [] }))
//                   );

//                 const all = await Promise.all(fetches);
//                 if (cancelled) return;

//                 const merged = all
//                   .flatMap((x) => (Array.isArray(x?.results) ? x.results : []))
//                   .filter(
//                     (v, i, arr) =>
//                       arr.findIndex((z) => z.epoNumber === v.epoNumber) === i
//                   );

//                 setSubsRows(merged);
//               } finally {
//                 if (!cancelled) setLoadingSubs(false);
//               }
//             })(),
//           ]);
//         }
//       } catch (e) {
//         if (!cancelled) setDirectReports([]);
//       }
//     };

//     setLoadingMine(true);
//     setLoadingAwaiting(true);
//     setLoadingSubs(true);
//     init();

//     return () => {
//       cancelled = true;
//     };
//   }, [userId]);

//   const handleCreateClick = () => {
//     setEditingEpoNumber(null);
//     setShowCreate(true);
//   };

//   const handleEdit = (row) => {
//     setEditingEpoNumber(row.epoNumber);
//     setShowCreate(true);
//   };

//   const handleCancel = () => {
//     setShowCreate(false);
//     setEditingEpoNumber(null);
//   };

//   const handleCreatedOrUpdated = async () => {
//     setShowCreate(false);
//     setEditingEpoNumber(null);
//     await loadMineEpos();
//     if (hasDirectReports) {
//       await loadAwaitingMyApproval();
//       await loadSubordinatesPending(directReports);
//     }
//   };

//   const title = useMemo(() => {
//     if (!hasDirectReports) return "My EPOs";
//     if (activeTab === "awaiting") return "Awaiting My Approval";
//     if (activeTab === "subs") return "My Subordinates’ EPOs";
//     return "My EPOs";
//   }, [hasDirectReports, activeTab]);

//   return (
//     <React.Fragment>
//       <div className="row">
//         <Col lg={12}>
//           <div className="card" id="tasksList">
//             <div className="card-header border-0">
//               <div className="d-flex align-items-center">
//                 <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
//                 <div className="flex-shrink-0">
//                   <button
//                     className="btn btn-danger add-btn me-1"
//                     onClick={handleCreateClick}
//                   >
//                     <i className="ri-add-line align-bottom me-1" />
//                     Create new EPO
//                   </button>
//                 </div>
//               </div>

//               {hasDirectReports && !showCreate && (
//                 <div className="mt-3">
//                   <Nav tabs className="nav-tabs-custom">
//                     <NavItem>
//                       <NavLink
//                         href="#"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           toggleTab("mine");
//                         }}
//                         className={classnames({ active: activeTab === "mine" })}
//                       >
//                         My EPOs
//                       </NavLink>
//                     </NavItem>

//                     <NavItem>
//                       <NavLink
//                         href="#"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           toggleTab("awaiting");
//                         }}
//                         className={classnames({ active: activeTab === "awaiting" })}
//                       >
//                         Awaiting My Approval
//                       </NavLink>
//                     </NavItem>

//                     <NavItem>
//                       <NavLink
//                         href="#"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           toggleTab("subs");
//                         }}
//                         className={classnames({ active: activeTab === "subs" })}
//                       >
//                         My Subordinates’ EPOs
//                       </NavLink>
//                     </NavItem>
//                   </Nav>
//                 </div>
//               )}
//             </div>

//             <div className="card-body pt-0">
//               {showCreate ? (
//                 <CreateEpoForm
//                   mode="edit"
//                   epoNumber={editingEpoNumber}
//                   onCancel={handleCancel}
//                   onCreated={handleCreatedOrUpdated}
//                 />
//               ) : (
//                 <Card>
//                   <CardBody>
//                     {hasDirectReports ? (
//                       <TabContent activeTab={activeTab} className="pt-3">
//                         <TabPane tabId="mine">
//                           {loadingMine ? (
//                             <div className="text-muted">Loading…</div>
//                           ) : (
//                             <SearchTableEPO data={mineRows} onEdit={handleEdit} />
//                           )}
//                         </TabPane>

//                         <TabPane tabId="awaiting">
//                           {loadingAwaiting ? (
//                             <div className="text-muted">Loading…</div>
//                           ) : (
//                             <SearchTableEPO data={awaitingRows} onEdit={handleEdit} />
//                           )}
//                         </TabPane>

//                         <TabPane tabId="subs">
//                           {loadingSubs ? (
//                             <div className="text-muted">Loading…</div>
//                           ) : (
//                             <SearchTableEPO data={subsRows} onEdit={handleEdit} />
//                           )}
//                         </TabPane>
//                       </TabContent>
//                     ) : loadingMine ? (
//                       <div className="text-muted">Loading…</div>
//                     ) : (
//                       <SearchTableEPO data={mineRows} onEdit={handleEdit} />
//                     )}
//                   </CardBody>
//                 </Card>
//               )}
//             </div>
//           </div>
//         </Col>
//       </div>
//     </React.Fragment>
//   );
// };

// export default AllTasks;



import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
} from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
// R43 — SearchTableEPO removed (3000-line mega-component, see R43 notes).
//        AllTasks now uses the lightweight EpoListTable with column-filter row.
import EpoListTable from "./EpoListTable";
// Rounds 2 batch — row-level Submit sends the same PDF approval email the form flow does.
import { getEpoPdfBase64 } from "./epoToPdf";
import { approveEpo } from "../../services/epoApprovalsApi";  // R25: bulk approve
import CreateEpoForm from "./CreateEpoForm";
import api from "../../api";
import "react-toastify/dist/ReactToastify.css";
import useEpoReviewModal from "../../hooks/useEpoReviewModal";
import EpoDecisionModal from "./EpoDecisionModal";
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import { ResponsiveTabs, TableSkeleton } from "../../Components/Common/DashboardKit";

/**
 * Pass 5 UI update (2026):
 *  - The three-tab Nav (My EPOs / Awaiting My Approval /
 *    My Subordinates' EPOs) — visible only when the current
 *    user has direct reports — has been migrated from the
 *    hand-rolled <Nav>/<NavItem>/<NavLink> pattern to the
 *    shared ResponsiveTabs component from the DashboardKit.
 *  - Each tab still carries its row count next to the label
 *    via ResponsiveTabs's `count` slot. The counts
 *    (mineCount / awaitingCount / subsCount) are unchanged.
 *  - The `toggleTab` handler still gates on activeTab so
 *    clicking the already-active tab is a no-op. The
 *    TabContent / TabPane lazy-mount block (which only
 *    renders an EpoListTable when that tab's data is loaded)  // R43
 *    is unchanged.
 *  - Removed the `classnames` import (only used by the old
 *    Nav strip's `className={classnames({ active: ... })}`).
 *    Removed Nav / NavItem / NavLink from the reactstrap
 *    import list.
 *  - Everything else is preserved exactly: loadMineEpos /
 *    loadAwaitingMyApproval / loadSubordinatesPending,
 *    every API endpoint (Epo/all?type=ALL&empId=...,
 *    epo/awaiting/:userId, OrgChart, /Epo/:n/duplicate,
 *    epo/:n/approve, epo/:n/reject), the directReports +
 *    hasDirectReports memo, the modals (EpoViewModal,
 *    EpoDecisionModal), the handleCreateClick / handleEdit /
 *    handleDuplicate / handleApprove / handleVoid /
 *    handleCancel / handleCreatedOrUpdated handlers, the
 *    cancelled-flag pattern in the init useEffect, the
 *    location.state.refresh handling, and the dynamic
 *    `title` memo are all unchanged.
 *  - The 365 lines of commented-out earlier-version code at
 *    the top of this file are preserved character-for-character
 *    since the team uses them as a historical reference.
 */
const getSubsArray = (node) => {
  if (!node) return [];
  const s = node.subordinates ?? node.Subordinates;
  if (Array.isArray(s)) return s;
  if (s?.$values && Array.isArray(s.$values)) return s.$values;
  return [];
};

const findNodeByEmpId = (root, empId) => {
  if (!root || !empId) return null;

  const stack = [];
  if (Array.isArray(root)) stack.push(...root);
  else stack.push(root);

  while (stack.length) {
    const cur = stack.pop();
    const curId = cur.empId ?? cur.EmpId;
    if (String(curId) === String(empId)) return cur;

    const kids = getSubsArray(cur);
    for (let i = 0; i < kids.length; i++) stack.push(kids[i]);
  }

  return null;
};

const normalizeEmpId = (s) => {
  const v = s?.empId ?? s?.EmpId ?? "";
  return v ? String(v) : "";
};


const AllTasks = () => {
  const userId = JSON.parse(sessionStorage.getItem("authUser"))?.uid;
  const navigate = useNavigate();

  const [showCreate, setShowCreate] = useState(false);
  const [editingEpoNumber, setEditingEpoNumber] = useState(null);

  const [activeTab, setActiveTab] = useState("mine");
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [mineRows, setMineRows] = useState([]);
  const [awaitingRows, setAwaitingRows] = useState([]);
  const [subsRows, setSubsRows] = useState([]);
  // R20 — status filter on the My EPOs tab. Backend supports the type param;
  // we just thread it through.
  const [mineStatus, setMineStatus] = useState("ALL");
  // R41/R43 — removed R18a/R29 page-level facet search state. The page now
  // uses EpoListTable (R43) which has the per-column filter row used by the
  // other EPO list pages (MpcEpoViewer, EposShipping, etc.).
  // R25 — bulk approve state for the Awaiting tab.
  const [bulkApproving, setBulkApproving] = useState(false);
  const [bulkNotice, setBulkNotice] = useState(null);

  // R41/R43 — facetFilter helper + filteredAwaiting/filteredSubs memos removed.
  // Pass raw rows directly to EpoListTable; column-filter row handles filtering.

  // R29 — URL-driven status filter. Clicking a stat card on the EPO
  // landing page navigates to /epo?status=X, which we honor here by
  // forcing the My EPOs tab + matching the dropdown.
  const [searchParams, setSearchParams] = useSearchParams();

  const [loadingMine, setLoadingMine] = useState(true);
  const [loadingAwaiting, setLoadingAwaiting] = useState(false);
  const [loadingSubs, setLoadingSubs] = useState(false);

  const [directReports, setDirectReports] = useState([]);

  const hasDirectReports = useMemo(
    () => (directReports?.length || 0) > 0,
    [directReports]
  );

  const mineCount = mineRows?.length || 0;
  const awaitingCount = awaitingRows?.length || 0;
  const subsCount = subsRows?.length || 0;
  const location = useLocation();

  useEffect(() => {
    loadMineEpos();

    if (location.state?.refresh) {
      window.history.replaceState({}, document.title);
    }

  }, [location.state]);

  // R29 — sync URL ?status= into the mine-status filter. Triggers a reload
  // because loadMineEpos depends on mineStatus through its closure capture.
  // We do NOT mirror state back to the URL on every dropdown change, only
  // ingest it on entry (avoids ping-ponging with the user manually changing
  // the dropdown).
  useEffect(() => {
    const urlStatus = (searchParams.get("status") || "").toUpperCase();
    const valid = ["ALL", "PENDING", "APPROVED", "DENIED"];
    if (!urlStatus || !valid.includes(urlStatus)) return;
    setActiveTab("mine");
    // Use the same handler the dropdown uses so the data reload fires.
    // setMineStatus alone wouldn't trigger loadMineEpos (the reload is
    // hand-fired from handleMineStatusChange, not from a state-watch effect).
    handleMineStatusChange(urlStatus);
    // Drop the param after consuming so revisits don't keep snapping back.
    searchParams.delete("status");
    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  // R17a — the /epo route always renders this AllTasks landing page; the
  // edit form only appears when showCreate=true. The internal duplicate flow
  // sets that flag itself, but external entry points (R17 timeline "Finance
  // Edit" button, EposNotReadyForPayment "Edit" links, bookmarks, shared
  // URLs) just navigate to /epo?mode=edit&epoNumber=N and expect the form to
  // appear. Before this effect, the URL changed but the form never rendered.
  // We watch location.search and lift mode/epoNumber into showCreate state.
  useEffect(() => {
    const q = new URLSearchParams(location.search || "");
    const mode = q.get("mode");
    const epoNumber = q.get("epoNumber");
    if (mode === "edit" && epoNumber) {
      const n = parseInt(epoNumber, 10);
      if (Number.isFinite(n) && n > 0) {
        setEditingEpoNumber(n);
        setShowCreate(true);
      }
    }
  }, [location.search]);
  const loadMineEpos = async (statusOverride, searchOverride, fieldOverride) => {
    setLoadingMine(true);
    try {
      // R20 — honour current status filter; backend understands ALL/PENDING/APPROVED/DENIED.
      const t = (statusOverride ?? mineStatus) || "ALL";
      // R18a — also send search + searchField if user has chosen a facet.
      // R41 — mineSearch/mineField removed; always pass empty for legacy compatibility.
      const term = searchOverride ?? "";
      const fld  = fieldOverride  ?? "all";
      let url = `Epo/all?type=${encodeURIComponent(t)}&empId=${userId}`;
      if (term && String(term).trim()) {
        url += `&search=${encodeURIComponent(String(term).trim())}`;
        if (fld && fld !== "all") url += `&searchField=${encodeURIComponent(fld)}`;
      }
      const res = await api.get(url);
      setMineRows(Array.isArray(res.data?.results) ? res.data.results : []);
    } finally {
      setLoadingMine(false);
    }
  };

  // R20 — status-filter handler: store + reload with the new type.
  const handleMineStatusChange = (next) => {
    setMineStatus(next);
    loadMineEpos(next, "", "all");  // R41 — mine search state removed
  };
  // R18a — facet search trigger + clear.
  // R41 — triggerMineSearch removed (no mine-tab search UI).
  const clearMineSearch = () => {
    setMineSearch(""); setMineField("all");
    loadMineEpos(mineStatus, "", "all");
  };
  // R25 — bulk approve. Walks current awaitingRows and calls approveEpo serially.
  const handleBulkApproveAwaiting = async () => {
    const rows = Array.isArray(awaitingRows) ? awaitingRows : [];
    if (rows.length === 0) return;
    if (!window.confirm(`Approve all ${rows.length} EPOs awaiting your approval? This cannot be undone.`)) return;
    setBulkApproving(true); setBulkNotice(null);
    let done = 0, failed = 0, firstErr = null;
    for (const row of rows) {
      const epoNum = row?.epoNumber ?? row?.EpoNumber ?? row?.EPONumber;
      if (epoNum == null) { failed++; continue; }
      try { await approveEpo(epoNum, ""); done++; }
      catch (e) {
        failed++;
        if (firstErr == null) firstErr = e?.response?.data?.error || e?.message || "failed";
        break;
      }
    }
    setBulkApproving(false);
    setBulkNotice(
      failed === 0
        ? `Approved ${done} EPO(s).`
        : `Approved ${done}, failed ${failed}${firstErr ? `: ${firstErr}` : ""}.`
    );
    await loadAwaitingMyApproval();
  };

  const loadAwaitingMyApproval = async () => {
    setLoadingAwaiting(true);
    try {
      const res = await api.get(`epo/awaiting/${userId}`);
      const results = Array.isArray(res.data?.results)
        ? res.data.results
        : Array.isArray(res.data)
          ? res.data
          : [];
      setAwaitingRows(results);
    } finally {
      setLoadingAwaiting(false);
    }
  };

  const loadSubordinatesPending = async (subs) => {
    setLoadingSubs(true);
    try {
      const fetches = (subs || [])
        .map((s) => normalizeEmpId(s))
        .filter(Boolean)
        .map((empId) =>
          api
            .get(`Epo/all?type=ALL&empId=${empId}`)
            .then((r) => r.data)
            .catch(() => ({ results: [] }))
        );

      const all = await Promise.all(fetches);

      const merged = all
        .flatMap((x) => (Array.isArray(x?.results) ? x.results : []))
        .filter(
          (v, i, arr) =>
            arr.findIndex((z) => z.epoNumber === v.epoNumber) === i
        );

      setSubsRows(merged);
    } finally {
      setLoadingSubs(false);
    }
  };

  // Rounds 2 batch — Submit-for-Approval straight from a My-EPOs row
  // (DRAFTs and legacy stuck PENDING EPOs flagged IsSubmittable by the API).
  const handleSubmitFromRow = async (row) => {
    const n = row?.epoNumber ?? row?.EpoNumber;
    if (!n) return;
    if (!window.confirm(`Submit EPO #${n} for approval?`)) return;
    try {
      await api.post(`epo/${n}/submit`);
      try {
        const pdfBase64 = await getEpoPdfBase64(n, api);
        await api.post(`Epo/${n}/notify`, { pdfBase64, fileName: `EPO-${n}.pdf` });
      } catch (mailErr) {
        console.error("Submit email failed (the submit itself succeeded):", mailErr);
      }
      toast.success(`EPO #${n} submitted for approval`);
    } catch (e) {
      toast.error(e?.response?.data?.error || "Submit failed. Please refresh and try again.");
    } finally {
      await loadMineEpos();
    }
  };

  // Owner authz fix — Finance Edit / Receive visibility now comes from the
  // SERVER's viewer flags on GET Epo/{n}; these props can only hide, never grant.
  const epoReview = useEpoReviewModal({ permissions: { canApprove: true, canPay: true, canManageAttachments: true } });

  const [decisionOpen, setDecisionOpen] = useState(false);
  const [decisionAction, setDecisionAction] = useState("approve");
  const [decisionEpoNumber, setDecisionEpoNumber] = useState(null);

  const handleView = (row) => {
    epoReview.open(row.epoNumber);
  };

  const openDecision = (action, row) => {
    setDecisionAction(action);
    setDecisionEpoNumber(row?.epoNumber || null);
    setDecisionOpen(true);
  };

  const closeDecision = () => {
    setDecisionOpen(false);
    setDecisionEpoNumber(null);
  };


  const approveApi = async (epoNumber, comment) => {
    await api.post(`epo/${epoNumber}/approve`, { comment: comment || "" });
  };

  const rejectApi = async (epoNumber, comment) => {
    await api.post(`epo/${epoNumber}/reject`, { comment: comment || "" });
  };



  const handleDecisionConfirm = async ({ epoNumber, comment }) => {
    try {
      if (decisionAction === "approve") {
        await approveApi(epoNumber, comment);
        toast.success(`EPO #${epoNumber} approved`);
      } else {
        await rejectApi(epoNumber, comment);
        toast.success(`EPO #${epoNumber} rejected`);
      }
      // R42 — production hygiene: debug log removed.
      await loadAwaitingMyApproval();
      if (hasDirectReports) await loadSubordinatesPending(directReports);
      await loadMineEpos();
    } catch (e) {
      toast.error("Action failed. Please try again.");
      throw e;
    }
  };

  useEffect(() => {
    if (!userId) return;

    let cancelled = false;

    const init = async () => {
      setLoadingMine(true);
      setLoadingAwaiting(true);
      setLoadingSubs(true);

      try {
        const mineRes = await api.get(`Epo/all?type=ALL&empId=${userId}`);
        if (!cancelled) {
          setMineRows(
            Array.isArray(mineRes.data?.results) ? mineRes.data.results : []
          );
        }
      } finally {
        if (!cancelled) setLoadingMine(false);
      }

      try {
        const orgRes = await api.get("OrgChart");
        const me = findNodeByEmpId(orgRes.data, userId);
        const subs = getSubsArray(me);

        if (!cancelled) setDirectReports(subs);

        if (subs.length > 0) {
          await Promise.all([
            (async () => {
              try {
                const res = await api.get(`epo/awaiting/${userId}`);
                if (cancelled) return;
                const results = Array.isArray(res.data?.results)
                  ? res.data.results
                  : Array.isArray(res.data)
                    ? res.data
                    : [];
                setAwaitingRows(results);
              } finally {
                if (!cancelled) setLoadingAwaiting(false);
              }
            })(),
            (async () => {
              try {
                const fetches = subs
                  .map((s) => normalizeEmpId(s))
                  .filter(Boolean)
                  .map((empId) =>
                    api
                      .get(`Epo/all?type=ALL&empId=${empId}`)
                      .then((r) => r.data)
                      .catch(() => ({ results: [] }))
                  );

                const all = await Promise.all(fetches);
                if (cancelled) return;

                const merged = all
                  .flatMap((x) =>
                    Array.isArray(x?.results) ? x.results : []
                  )
                  .filter(
                    (v, i, arr) =>
                      arr.findIndex((z) => z.epoNumber === v.epoNumber) === i
                  );

                setSubsRows(merged);
              } finally {
                if (!cancelled) setLoadingSubs(false);
              }
            })(),
          ]);
        } else {
          if (!cancelled) {
            setLoadingAwaiting(false);
            setLoadingSubs(false);
          }
        }
      } catch {
        if (!cancelled) {
          setDirectReports([]);
          setLoadingAwaiting(false);
          setLoadingSubs(false);
        }
      }
    };

    init();

    return () => {
      cancelled = true;
    };
  }, [userId]);

  const handleCreateClick = () => {
    setEditingEpoNumber(null);
    setShowCreate(true);
    // R34 — drop any stale ?mode=edit&epoNumber=X so CreateEpoForm's
    // queryEpoNumber fallback doesn't pollute its load effect / modal logic.
    // Other query params (?status=, etc.) are preserved.
    const sp = new URLSearchParams(location.search);
    if (sp.has("mode") || sp.has("epoNumber")) {
      sp.delete("mode");
      sp.delete("epoNumber");
      const qs = sp.toString();
      navigate(qs ? `/epo?${qs}` : "/epo", { replace: true });
    }
  };

  const handleEdit = (row) => {
    setEditingEpoNumber(row.epoNumber);
    setShowCreate(true);
  };


  // R45 — add `duplicated=1` to the URL so CreateEpoForm knows the
  // session was kicked off by a duplicate. That flag flips the post-save
  // modal from "EPO Updated" → "EPO Saved!" (with the Submit-for-Approval
  // button), so the notification email goes out the same way it does for
  // a brand-new EPO. Previously duplicate landed in plain edit mode and
  // the email was never sent.
  const handleDuplicate = async (rowData) => {
    try {
      const sourceEpoNum = rowData.epoNumber ?? rowData.EpoNumber ?? rowData.ePONumber ?? rowData.EPONumber;
      const res = await api.post(`/Epo/${sourceEpoNum}/duplicate`);

      const newEpoNum = res.data?.epoNumber;

      if (!newEpoNum) {
        console.error("Duplicate failed. No epoNumber returned.");
        return;
      }

      setEditingEpoNumber(newEpoNum);
      navigate(`/epo?mode=edit&epoNumber=${newEpoNum}&duplicated=1`);
      setShowCreate(true);
    } catch (err) {
      console.error("Error duplicating EPO:", err);
    }
  };

  // const handleView = (row) => {
  //   const epoNum = row?.epoNumber;
  //   if (!epoNum) return;
  //   navigate(`/epo/${epoNum}/timeline`);
  // };

  const handleApprove = (row) => openDecision("approve", row);
  const handleVoid = (row) => openDecision("reject", row);



  const handleCancel = () => {
    setShowCreate(false);
    setEditingEpoNumber(null);
    // R34 — drop any stale ?mode=edit&epoNumber=X so CreateEpoForm's
    // queryEpoNumber fallback doesn't pollute its load effect / modal logic.
    // Other query params (?status=, etc.) are preserved.
    const sp = new URLSearchParams(location.search);
    if (sp.has("mode") || sp.has("epoNumber")) {
      sp.delete("mode");
      sp.delete("epoNumber");
      const qs = sp.toString();
      navigate(qs ? `/epo?${qs}` : "/epo", { replace: true });
    }
  };

  const handleCreatedOrUpdated = async () => {
    setShowCreate(false);
    setEditingEpoNumber(null);
    // R34 — drop any stale ?mode=edit&epoNumber=X so CreateEpoForm's
    // queryEpoNumber fallback doesn't pollute its load effect / modal logic.
    // Other query params (?status=, etc.) are preserved.
    const sp = new URLSearchParams(location.search);
    if (sp.has("mode") || sp.has("epoNumber")) {
      sp.delete("mode");
      sp.delete("epoNumber");
      const qs = sp.toString();
      navigate(qs ? `/epo?${qs}` : "/epo", { replace: true });
    }

    await loadMineEpos();
    if (hasDirectReports) {
      await loadAwaitingMyApproval();
      await loadSubordinatesPending(directReports);
    }
  };

  const title = useMemo(() => {
    if (!hasDirectReports) return "My EPOs";
    if (activeTab === "awaiting") return "Awaiting My Approval";
    if (activeTab === "subs") return "My Subordinates’ EPOs";
    return "My EPOs";
  }, [hasDirectReports, activeTab]);

  // Reshape the three-tab strip for ResponsiveTabs. Counts are
  // always shown next to the label via the kit's `count` slot.
  // Only built when the user has direct reports (the strip is
  // only rendered in that case).
  const kitTabs = useMemo(() => ([
    { key: "mine",     label: "My EPOs",                  count: mineCount },
    { key: "awaiting", label: "Awaiting My Approval",     count: awaitingCount },
    { key: "subs",     label: "My Subordinates’ EPOs",    count: subsCount },
  ]), [mineCount, awaitingCount, subsCount]);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="row">
        <Col lg={12}>
          <div className="card" id="tasksList">
            <div className="card-header border-0">
              {/* R32a — hide the "My EPOs / Create new EPO" header strip
                  while the Review/Edit form is open. The form has its own
                  title bar ("Review EPO #N") so the landing-page chrome is
                  noise and — worse — misleads Finance into thinking they're
                  looking at their own EPO list. */}
              {!showCreate && (
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
                  <div className="flex-shrink-0">
                    <button
                      className="btn btn-danger add-btn me-1"
                      onClick={handleCreateClick}
                    >
                      <i className="ri-add-line align-bottom me-1" />
                      Create new EPO
                    </button>
                  </div>
                </div>
              )}

              {hasDirectReports && !showCreate && (
                <div className="mt-3">
                  <ResponsiveTabs
                    tabs={kitTabs}
                    activeKey={activeTab}
                    onChange={toggleTab}
                    variant="underline"
                    color="primary"
                  />
                </div>
              )}
            </div>

            <div className="card-body pt-0">
              {showCreate ? (
                <CreateEpoForm
                  mode="edit"
                  epoNumber={editingEpoNumber}
                  onCancel={handleCancel}
                  /* R40 — onCreated prop removed (dead code; refresh via navigate state). */
                />
              ) : (
                <Card>
                  <CardBody>
                    {hasDirectReports ? (
                      <TabContent activeTab={activeTab} className="pt-3">
                        <TabPane tabId="mine">
                          {/* R29 — facet search removed (moved to Awaiting + Subordinates
                              tabs). Status dropdown is kept; that's the only filter on My EPOs.
                              Stat cards on the parent page act as quick filters via ?status=. */}
                          <div className="d-flex gap-2 align-items-center mb-2 flex-wrap">
                            <label className="form-label mb-0 small text-muted">Status:</label>
                            <select className="form-select form-select-sm" style={{ maxWidth: 180 }}
                              value={mineStatus} onChange={(e) => handleMineStatusChange(e.target.value)}>
                              <option value="ALL">All</option>
                              <option value="PENDING">Pending</option>
                              <option value="APPROVED">Approved</option>
                              <option value="DENIED">Denied / Void</option>
                            </select>
                          </div>
                          {loadingMine ? (
                            <div className="table-responsive epo-sticky-head">
                              <table className="table align-middle mb-0">
                                <tbody><TableSkeleton rows={5} columns={6} /></tbody>
                              </table>
                            </div>
                          ) : (
                            <EpoListTable
                              data={mineRows}
                              mode="mine"
                              onEdit={handleEdit}
                              onView={handleView}
                              onDuplicate={handleDuplicate}
                              onSubmit={handleSubmitFromRow}
                              emptyTitle="No EPOs yet"
                              emptyDescription="Create one with the Create New EPO button above."
                            />
                          )}
                        </TabPane>

                        <TabPane tabId="awaiting">
                          {/* R41/R43 — R29 facet search bar removed. EpoListTable's
                              column-filter row handles filtering now. */}
                          {/* R25 — Approve All bulk action. */}
                          <div className="d-flex justify-content-between align-items-center mb-2 gap-2 flex-wrap">
                            <div className="small text-muted">{awaitingRows?.length || 0} EPO(s) awaiting your approval.</div>
                            <div className="d-flex gap-2 align-items-center">
                              {bulkNotice && (<span className="badge bg-info text-dark">{bulkNotice}</span>)}
                              <button type="button" className="btn btn-success btn-sm"
                                disabled={bulkApproving || !awaitingRows || awaitingRows.length === 0}
                                onClick={handleBulkApproveAwaiting}
                                title="Approves all rows in the table">
                                <i className="ri-check-double-line align-bottom me-1"></i>
                                {bulkApproving ? "Approving…" : "Approve All"}
                              </button>
                            </div>
                          </div>
                          {loadingAwaiting ? (
                            <div className="table-responsive epo-sticky-head">
                              <table className="table align-middle mb-0">
                                <tbody><TableSkeleton rows={5} columns={6} /></tbody>
                              </table>
                            </div>
                          ) : (
                            <EpoListTable
                              data={awaitingRows}
                              mode="awaiting"
                              onView={handleView}
                              onApprove={handleApprove}
                              onVoid={handleVoid}
                              emptyTitle="Inbox clear"
                              emptyDescription="No EPOs are currently awaiting your approval."
                            />
                          )}
                        </TabPane>

                        <TabPane tabId="subs">
                          {/* R41 — R29 facet search bar removed. */}
                          <div className="d-flex gap-2 align-items-center mb-2 flex-wrap">
                            <div className="small text-muted ms-auto">{subsRows?.length || 0} EPO(s) from your reports.</div>
                          </div>
                          {loadingSubs ? (
                            <div className="table-responsive epo-sticky-head">
                              <table className="table align-middle mb-0">
                                <tbody><TableSkeleton rows={5} columns={6} /></tbody>
                              </table>
                            </div>
                          ) : (
                            <EpoListTable
                              data={subsRows}
                              mode="subs"
                              onView={handleView}
                              emptyTitle="No subordinate EPOs"
                              emptyDescription="None of your direct or indirect reports have created EPOs."
                            />
                          )}
                        </TabPane>
                      </TabContent>
                    ) : (
                      <>
                        {/* R20 — status filter (no-reports / mine-only view). */}
                        <div className="d-flex gap-2 align-items-center mb-2">
                          <label className="form-label mb-0 small text-muted">Status:</label>
                          <select
                            className="form-select form-select-sm"
                            style={{ maxWidth: 180 }}
                            value={mineStatus}
                            onChange={(e) => handleMineStatusChange(e.target.value)}
                          >
                            <option value="ALL">All</option>
                            <option value="PENDING">Pending</option>
                            <option value="APPROVED">Approved</option>
                            <option value="DENIED">Denied / Void</option>
                          </select>
                        </div>
                        {loadingMine ? (
                          <div className="table-responsive epo-sticky-head">
                            <table className="table align-middle mb-0">
                              <tbody><TableSkeleton rows={5} columns={6} /></tbody>
                            </table>
                          </div>
                        ) : (
                          <EpoListTable
                            data={mineRows}
                            mode="mine"
                            onEdit={handleEdit}
                            onView={handleView}
                            onDuplicate={handleDuplicate}
                            emptyTitle="No EPOs yet"
                            emptyDescription="Create one with the Create New EPO button above."
                          />
                        )}
                      </>
                    )}
                    {epoReview.element}
                    <EpoDecisionModal
                      isOpen={decisionOpen}
                      toggle={closeDecision}
                      action={decisionAction}
                      epoNumber={decisionEpoNumber}
                      onConfirm={handleDecisionConfirm}
                    />
                  </CardBody>
                </Card>
              )}
            </div>
          </div>
        </Col>
      </div>
    </React.Fragment>
  );
};

export default AllTasks;
